exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-submit.disabled[data-v-106115f2]{cursor:default}.btn-submit.disabled[data-v-106115f2]:hover{background-color:#efefef}", ""]);

// exports
